import { useSEO } from "@/hooks/useSEO";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Gallery() {
  useSEO({ title: "Nassau Bahamas Car Rental Gallery | Easy Drive", description: "See the Easy Drive fleet and the beauty of Nassau, New Providence and Paradise Island — real photos from the island we call home.", path: "/gallery" });
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="gallery-page" className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-[11px] font-ui tracking-[0.3em] uppercase text-primary">Island Gallery</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl tracking-tight">
          Life on <span className="italic gold-text">island time</span>
        </h1>
        <p className="mt-4 text-muted-foreground max-w-2xl leading-relaxed text-sm sm:text-base">
          Real moments from our fleet and our island — delivered, detailed and ready for yours.
        </p>
        {loading ? (
          <p className="mt-16 text-center text-muted-foreground font-ui text-sm">Loading gallery…</p>
        ) : items.length === 0 ? (
          <p data-testid="gallery-page-empty" className="mt-16 text-center text-muted-foreground font-ui text-sm">Photos coming soon.</p>
        ) : (
          <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((g) => (
              <div key={g.id} data-testid={`gallery-page-item-${g.id}`} className="rounded-2xl overflow-hidden border border-border aspect-[4/3] bg-black/5">
                {g.kind === "video" ? (
                  <video src={g.url} autoPlay muted loop playsInline className="w-full h-full object-cover" />
                ) : (
                  <img src={g.url} alt={g.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
